import { render, staticRenderFns } from "./index.vue?vue&type=template&id=8ef6ff5a&scoped=true"
import script from "./index.vue?vue&type=script&lang=js"
export * from "./index.vue?vue&type=script&lang=js"
import style0 from "./index.vue?vue&type=style&index=0&id=8ef6ff5a&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8ef6ff5a",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/shorlyn/Documents/project/core/campus-all/rccms-web/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('8ef6ff5a')) {
      api.createRecord('8ef6ff5a', component.options)
    } else {
      api.reload('8ef6ff5a', component.options)
    }
    module.hot.accept("./index.vue?vue&type=template&id=8ef6ff5a&scoped=true", function () {
      api.rerender('8ef6ff5a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/AiChat/index.vue"
export default component.exports